import React, { useState, useEffect } from "react";
import {
  GET_ALL_GAMESLIST,
  GET_ALL_JACKPOT_GAME_CHART,
  GET_ALL_STARTLINE_GAMES_CHART,
  GET_ALL_STARLINE_PANA_CHART,
} from "../../service/admin.service";
import { Link } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

/*   SKELETON CARD
 */
const SkeletonCard = () => (
  <div className="tw-animate-pulse tw-bg-gray-200 tw-h-12 tw-rounded-xl tw-w-full" />
);

/*   GAME GRID
 */
const GameGrid = ({ content = [], type, loading }) => {
  const selectGameType = (type, item) => {
    const rawName =
      item.providerName || item.provider_name || item.name || "unknown";

    if (type === "lottery") {
      return `/lottery/${rawName}/${item._id}`;
    }

    return `/charts-tbl/${type}/${rawName}/${item._id}`;
  };

  const combinedContent = [];

  if (!loading) {
    if (type === "starline") {
      combinedContent.push({
        _id: "all-starline",
        providerName: "ALL STARLINE CHART",
        isAllChart: true,
        link: "/charts/starline-all",
      });
    }
    if (type === "jackpot") {
      combinedContent.push({
        _id: "all-jackpot",
        providerName: "ALL JACKPOT CHART",
        isAllChart: true,
        link: "/charts/jackpot-all",
      });
    }
  }

  const finalContent = [...combinedContent, ...(content || [])];

  const sortedContent = [...finalContent].sort((a, b) => {
    const aLabel = a.providerName || a.provider_name || a.name || "";
    const bLabel = b.providerName || b.provider_name || b.name || "";
    return (bLabel.length > 16 ? 1 : 0) - (aLabel.length > 16 ? 1 : 0);
  });

  return (
    <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 lg:tw-grid-cols-4 tw-gap-4 tw-bg-gray-50 tw-p-4 tw-rounded-2xl tw-shadow-sm">
      {loading &&
        Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)}

      {!loading &&
        sortedContent.map((item) => {
          const label =
            item.providerName || item.provider_name || item.name || "";
          const isLong = label.length > 16;

          return (
            <Link
              key={item._id}
              to={item.isAllChart ? item.link : selectGameType(type, item)}
              state={item.isAllChart ? {} : { type, item }}
              className={`
                text-gray-700 tw-bg-gray-200 tw-py-2 tw-px-3
                tw-rounded-md tw-font-medium tw-text-sm
                hover:tw-text-white hover:tw-bg-[#04b3f3]
                tw-transition-colors tw-duration-300
                tw-flex tw-items-center tw-justify-center
                tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis
                ${isLong ? "tw-col-span-2 md:tw-col-span-1 lg:tw-col-span-2" : ""}
              `}
              title={label}
            >
              {label}
            </Link>
          );
        })}
    </div>
  );
};

/*   ACCORDION
 */
const Accordion = ({ title, content, type, loading }) => {
  return (
    <div className="tw-my-4">
      <button
        className="
          tw-bg-[#2359db]
hover:tw-bg-[#1d4fc2]
          tw-w-full
          tw-text-white
          tw-py-3 tw-px-6
          tw-rounded-2xl
          tw-font-bold
          tw-text-base
          tw-shadow-md
          tw-transition-all tw-duration-300
        "
      >
        {title}
      </button>

      <div className="tw-mt-3 tw-transition-all tw-duration-500">
        <GameGrid content={content} type={type} loading={loading} />
      </div>
    </div>
  );
};

/*   MAIN PAGE
 */
export default function AccordionPage() {
  const [AllMainGames, setAllMainGames] = useState([]);
  const [AllStarlineGames, setAllStarlineGames] = useState([]);
  const [AllJackpotGames, setAllJackpotGames] = useState([]);
  const [loading, setLoading] = useState(true);

  const GetAllGemeList = async () => {
    try {
      setLoading(true);

      const [mainRes, starlineRes, jackpotRes] = await Promise.all([
        GET_ALL_GAMESLIST(),
        GET_ALL_STARTLINE_GAMES_CHART(),
        GET_ALL_JACKPOT_GAME_CHART(),
        GET_ALL_STARLINE_PANA_CHART(),
      ]);

      setAllMainGames(mainRes?.data || []);
      setAllStarlineGames(starlineRes?.data || []);
      setAllJackpotGames(jackpotRes?.data || []);
    } catch (error) {
      console.error("Error fetching games:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetAllGemeList();
  }, []);

  const data = [
    { title: "JODI CHARTS", content: AllMainGames, type: "jodi" },
    { title: "PANA CHARTS", content: AllMainGames, type: "pana" },
    { title: "STARLINE GAMES", content: AllStarlineGames, type: "starline" },
    { title: "JACKPOT GAMES", content: AllJackpotGames, type: "jackpot" },
  ];

  return (
    <>
      <Navbar />
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 md:tw-px-8 tw-py-10 tw-bg-white tw-mt-24">
        <h3 className="tw-text-center tw-text-gray-700  tw-text-3xl md:tw-text-4xl tw-font-bold tw-mb-2">
          All Charts & Games
        </h3>

        <p className="tw-text-center tw-mb-8 tw-text-gray-500 tw-text-sm md:tw-text-base tw-max-w-xl tw-mx-auto tw-leading-relaxed">
          We Have Best Game Rates In Market
        </p>

        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-8">
          {data.map((item, index) => (
            <Accordion
              key={index}
              title={item.title}
              content={item.content}
              type={item.type}
              loading={loading}
            />
          ))}
        </div>

        <div className="tw-flex tw-justify-center tw-mt-12">
          <button
            onClick={() => window.history.back()}
            className="
            tw-bg-[#2359db]
hover:tw-bg-[#1d4fc2]
            tw-text-white
            tw-font-semibold
            tw-py-3 tw-px-8
            tw-rounded-xl
            tw-shadow-md
            tw-transition-all tw-duration-300
          "
          >
            ← Back
          </button>
        </div>
      </div>
      <Footer />
    </>
  );
}
